import { render, staticRenderFns } from "./CreateGroupConversation.vue?vue&type=template&id=a6955006"
import script from "./CreateGroupConversation.vue?vue&type=script&lang=ts"
export * from "./CreateGroupConversation.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a6955006')) {
      api.createRecord('a6955006', component.options)
    } else {
      api.reload('a6955006', component.options)
    }
    module.hot.accept("./CreateGroupConversation.vue?vue&type=template&id=a6955006", function () {
      api.rerender('a6955006', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/inbox/CreateGroupConversation.vue"
export default component.exports